module.exports = __webpack_public_path__ + "img/Wp_2005.44ee9f28.png";